import { motion } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";

export const Hero = () => {
  const handleViewWork = () => {
    const section = document.getElementById("our-portfolio");
    if (!section) return;

    section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden flex items-center justify-center text-center">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          poster="https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?q=80&w=1988&auto=format&fit=crop">
          <source src="/videos/hero-bg.mp4" type="video/mp4" />
        </video>
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/80 z-10" />
        {/* Bottom Gradient for seamless blend */}
        <div className="absolute bottom-0 left-0 w-full h-32 bg-linear-to-t from-black via-black/50 to-transparent z-10" />
      </div>

      {/* Content */}
      <div className="relative z-20 px-6 max-w-5xl mx-auto flex flex-col items-center">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="font-serif text-5xl md:text-7xl lg:text-8xl font-light leading-tight text-white mb-8">
          Crafting World-Class <br />
          <span className="italic">Aviation Experiences.</span>
        </motion.h1>

        {/* Stats Row */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="flex flex-wrap justify-center gap-6 md:gap-12 text-gray-300 font-light text-lg md:text-xl mb-10 tracking-wide">
          <span>20+ Years Excellence</span>
          <span className="hidden md:inline text-gray-500">|</span>
          <span>300+ Projects</span>
        </motion.div>
        {/* Stats Row */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
          className="flex flex-wrap justify-center gap-6 md:gap-12 text-gray-300 font-light text-lg md:text-xl mb-10 tracking-wide">
          <p className="max-w-xl text-lg md:text-xl font-light text-gray-200 mb-10 leading-relaxed drop-shadow-sm">
            From high-security aviation hubs to luxury spaces, we build for the
            giants of AVIATION INDUSTRY. Specialized in Civil, Interiors &
            Mechanical contracting.
          </p>
        </motion.div>

        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
          onClick={handleViewWork}
          className="group flex items-center gap-3 border border-white px-8 py-3 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-full">
          <span className="text-lg font-medium">View Our Work</span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </motion.button>
      </div>

      {/* Scroll Down Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{ delay: 1.5, duration: 2, repeat: Infinity }}
        className="absolute bottom-10 z-20">
        <ChevronDown className="w-8 h-8 text-primary" />
      </motion.div>
    </section>
  );
};
